module.exports = __webpack_public_path__ + "static/media/expert.2228deaa.svg";